import _ from 'underscore';
import { ListItem, SingleSelectDropdown, DropdownButtonType, List, ButtonWidget, ActivitySpinnerWidget, ActivitySpinnerSize, ButtonType, } from '@tableau/widgets';
import React from 'react';
import { Messages } from '~src/codegen/Localize';
import { IOAuthCredential } from '~src/ts/ServerApi/types/IOAuthCredential';

export interface CheckOAuthConnectionCredentialsProps {
    addOAuthCredentialsOptionText: string;
    addOAuthCredentialsOptionValue: string;
    advisoryText: string;
    chooseCredentialsText: string;
    dialogDescription: string;
    oAuthCredentials: IOAuthCredential[];
    selectedOAuthCredentialsId: string;
    close: (result?: any) => void;
    onSelectionChange: (
        id: string,
        setSelectedId: (id: string) => void,
        setOAuthCredentials: (credentials: IOAuthCredential[]) => void
    ) => void;
    signIn: (
        selectedOAuthCredentialsId: string,
        close: (result?: any) => void
    ) => Promise<any>;
}

function OAuthCredentialForm(props: CheckOAuthConnectionCredentialsProps) {

    const [selectedId, setSelectedId] = React.useState('');
    const [busy, setBusy] = React.useState(false);
    const [oAuthCredentials, setOAuthCredentials] = React.useState(props.oAuthCredentials);

    const listItems: ListItem[] = oAuthCredentials.map(credential => ({
        value: credential.id,
        content: credential.username
    }));
    listItems.unshift({ value: props.addOAuthCredentialsOptionValue, content: props.addOAuthCredentialsOptionText });

    const handleSelectionChange = (id: string) => props.onSelectionChange(id, setSelectedId, setOAuthCredentials);

    const handleSignIn = (event: React.FormEvent) => {
        event.preventDefault();
        setBusy(true);
        props.signIn(selectedId, props.close).then(_value => {
            // Sign-in successful, dialog will close
        }, _reason => {
            // Sign-in failed, try again
            setBusy(false);
        });
    };

    return (
        <>
            <div className='tb-connection-credentials-form'>
                {oAuthCredentials.length > 0 ? (
                    <SingleSelectDropdown
                        label={props.chooseCredentialsText}
                        testId='oauth-credential-dropdown'
                        type={DropdownButtonType.Outline}
                        list={<List items={listItems} />}
                        onChange={handleSelectionChange}
                        value={selectedId}
                    />
                ) : null
                }
            </div>
            <div className='tb-o-auth-sign-in'>
                <ButtonWidget
                    className='tb-outline-button tb-go-button'
                    buttonType={ButtonType.Primary}
                    testId='o-auth-credential-sign-in'
                    disabled={oAuthCredentials.length > 0 && (!selectedId || busy)}
                    onClick={handleSignIn}
                >
                    <>
                        {oAuthCredentials.length > 0 && busy ? (
                            <span className='tb-icon-spinner tb-lr-padded-narrow' />
                        ) : null}
                        <span>{Messages.signIn()}</span>
                    </>
                </ButtonWidget>
            </div>
            { oAuthCredentials.length === 0 && (
                <div className='tb-embedded-auth-advisory'>{props.advisoryText}</div>
            )
            }
        </>
    );
}

export function CheckOAuthConnectionCredentialsDialog(props: CheckOAuthConnectionCredentialsProps) {
    return (
        <>
            <div className='tb-dialog-description'>{props.dialogDescription}</div>
            <OAuthCredentialForm {...props} />
        </>
    );
}
